import createTableStore from "ds/components/Table/store/useTableStore";

import {
  VCS_INTEGRATIONS_TABLE_COLUMNS_CONFIG,
  VCS_INTEGRATIONS_TABLE_STORAGE_KEY,
} from "./constants";

const useVCSIntegrationsTableStore = createTableStore({
  storageKey: VCS_INTEGRATIONS_TABLE_STORAGE_KEY,
  config: VCS_INTEGRATIONS_TABLE_COLUMNS_CONFIG,
});

export default useVCSIntegrationsTableStore;
